<app-map
  #map
  id="map"
  [zoom]="mapZoom"
  [focusZoom]="focusZoom()"
  [spots]="(visibleSpots$ | async) ?? []"
  [dots]="(visibleDots$ | async) ?? []"
  [selectedSpot]="selectedSpot()"
  [selectedChallenge]="selectedChallenge()"
  [selectedSpotChallenges]="selectedSpotChallenges()"
  [markers]="visibleMarkers.asReadonly()()"
  [polygons]="polygons()"
  [selectedMarker]="selectedMarker()"
  [isEditing]="isEditing()"
  [showGeolocation]="showGeolocation"
  [boundRestriction]="boundRestriction"
  [minZoom]="minZoom"
  [mapStyle]="mapStyle() ?? 'roadmap'"
  [showSpotPreview]="showSpotPreview()"
  (boundsChange)="mapBoundsChanged($event, mapZoom)"
  (visibleTilesChange)="visibleTilesChanged($event)"
  (zoomChange)="zoomChanged($event)"
  (mapClick)="isClickable() ? mapClick($event) : null"
  (spotClick)="isClickable() ? openSpotByWhateverMeansNecessary($event) : null"
  (centerChange)="mapCenter = $event"
  (hasGeolocationChange)="hasGeolocationChange.emit($event)"
  (markerClickEvent)="markerClickEvent.emit($event)"
></app-map>
